import { cn } from '@/lib/utils'

interface Props {
  caseType: string
  recentlyUpdated?: boolean
}

export const CellContentCaseType = ({ caseType, recentlyUpdated = false }: Props) => {
  return (
    <div className={cn('flex items-center gap-2', 'whitespace-nowrap', recentlyUpdated && 'font-bold')}>
      {recentlyUpdated && <NewUpdateMark />}
      {caseType || '-'}
    </div>
  )
}

const NewUpdateMark = () => {
  return (
    <div
      className={cn(
        'h-[20px] w-[29px] rounded-md border border-blue-100 bg-blue-50',
        'flex items-center justify-center',
        'text-xs font-bold text-blue-500'
      )}
    >
      N
    </div>
  )
}
